import React from 'react'

const SlotGamePopupGameCard = () => {
    return (
        <>
            <div className='text-center cursor-pointer m-[2px] md:m-[6px]'>	<img src="https://vedaimg.enjoycx.com/img/game/bng/bnglobby.jpg" className='w-full h-[135px]' />
                <span className='block h-[25px] leading-[25px] text-xs mt-1 text-white bg-[#252525] font-Time'>BNG 로비</span>
            </div>
        </>
    )
}

export default SlotGamePopupGameCard